const VK_HOSTS = ['userapi.com', 'vkuserphoto.ru', 'vk.com', 'vkontakte.ru'];

const isVkUrl = (url) => {
  if (!url) return false;
  try {
    const parsed = new URL(url);
    return VK_HOSTS.some(host => parsed.hostname === host || parsed.hostname.endsWith(`.${host}`));
  } catch {
    return false;
  }
};

const measureImage = (url) => new Promise((resolve) => {
  const img = new Image();
  const timer = setTimeout(() => resolve(0), 4000);
  img.onload = () => {
    clearTimeout(timer);
    resolve(img.naturalWidth || 0);
  };
  img.onerror = () => {
    clearTimeout(timer);
    resolve(0);
  };
  img.src = url;
});

// VK CDN отдаёт размер из параметра cs/size, если он есть в ссылке.
export const getLargeVkPhoto = async (url) => {
  if (!isVkUrl(url)) return url;

  let upgraded = null;
  try {
    const parsed = new URL(url);
    if (parsed.searchParams.has('cs')) {
      parsed.searchParams.set('cs', '1080x1080');
      upgraded = parsed.toString();
    } else if (parsed.searchParams.has('size')) {
      parsed.searchParams.set('size', '1080x1080');
      upgraded = parsed.toString();
    }
  } catch {
    return url;
  }

  if (!upgraded || upgraded === url) return url;

  const [originalWidth, upgradedWidth] = await Promise.all([
    measureImage(url),
    measureImage(upgraded),
  ]);

  return upgradedWidth > originalWidth ? upgraded : url;
};

export const fetchVkPhotoMaxOrig = (accessToken, userId) => new Promise((resolve) => {
  const callbackName = `vk_photo_cb_${Date.now()}`;
  const script = document.createElement('script');
  script.src = `https://api.vk.com/method/users.get?user_ids=${userId}&fields=photo_max_orig&access_token=${accessToken}&v=5.199&callback=window.${callbackName}`;

  const cleanup = () => {
    clearTimeout(timeoutId);
    delete window[callbackName];
    script.remove();
  };

  const timeoutId = setTimeout(() => {
    cleanup();
    resolve('');
  }, 5000);

  window[callbackName] = (response) => {
    const photo = response?.response?.[0]?.photo_max_orig || '';
    cleanup();
    resolve(photo);
  };

  script.onerror = () => {
    cleanup();
    resolve('');
  };

  document.head.appendChild(script);
});
